import {
  createNamedAction
} from 'helpers/ActionUtil'

import {
  RUN_RISK_VALIDATION
} from './constants'

const runRiskValidation = () => ({ type: RUN_RISK_VALIDATION })

export default (path) => {
  return {
    runRiskValidation: createNamedAction(path, runRiskValidation),
  }
}
